// src/redux/reducers/cityReducer.js
import {
    FETCH_GETSPECIALIZATION_FAILURE,
    FETCH_GETSPECIALIZATION_REQUEST,
    FETCH_GETSPECIALIZATION_SUCCESS, 
    SET_SELECTED_GETSPECIALIZATION 
  } from '../types'; 
  
  const initialState = {
    loading: false,
    SpecializationList: [],
    selectedSpecializationId: null, 
    error: null,
  };
  
  const specializationReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETSPECIALIZATION_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETSPECIALIZATION_SUCCESS:
        return { ...state, loading: false, SpecializationList: action.payload };
      case FETCH_GETSPECIALIZATION_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETSPECIALIZATION:
        return { ...state, selectedSpecializationId: action.payload };
      default:
        return state;
    }
  };
  
  export default specializationReducer;
  
  